import Component from '../abstracts/Component';
import {SmoothScroll} from '../utils/SmoothScroll';

export default class BookingToolComponent extends Component {

  constructor() {
    super();

    let _this = this;

    this.Opened = false;
    this.panel = $('.js-custom-panel');
    this.trigger = $('.panel-trigger');
    this.triggerTownRegion = $('.js-load-town-region');

    let timing = this.panel.data('animate-time');

    if (timing) {
      this.animateTime = this.panel.data('animate-time');
    } else {
      this.animateTime = 350;
    }

    this.trigger.on('click.panel', (e) => {
      let target = e.currentTarget.dataset.target
      e.currentTarget.style.display = 'none';
      this.openPanel(target);
    })

    this.triggerTownRegion.on('click', (e) => {
      _this.townRegionAjax();
    })
  }

  townRegionAjax() {
    let _this = this;

    const selectedInput = document.querySelector('[name=chooseOccasion]:checked');
    let selectedFeature = selectedInput.value;
    let url = $('#specialStoreTownSelect')[0].dataset.url;

    $.ajax({
      type: "GET",
      contentType: "application/json",
      dataType: 'json',
      data: {
        selectedFeature: selectedFeature,
        getRegionTownMapByFeature: true
      },
      url: url,
      cache: false,
      success: function (response) {
        var myJSONText = JSON.stringify(response);
        var townAndRegions = JSON.parse(myJSONText);
        _this.fillDivWithOptions(townAndRegions);
      },
      error: function (errorObj, textStatus, errorThrown) {
      }
    });
  }

  fillDivWithOptions(townAndRegions) {
    let message = $('#specialStoreTownSelect')[0].dataset.message;
    var options = '';
    $('#specialStoresByTown').empty();

    $('#specialStoreTownSelect').empty();

    options = `
        <option disabled="disabled" selected="selected" value="">${message}</option>
      `;

    $.each(townAndRegions, function (index, townsAndRegion) {
      // const regionArea = townsAndRegion.regionArea;
      const towns = townsAndRegion.towns;

      /*
      options = options + `
          <option id="${regionArea}" value="${regionArea}" disabled="disabled">${regionArea}</option>
        `;
      */

      $.each(towns, function (index, town) {
        let townClear = town.replace(/ /g, '_');
        let townId = townClear.replace(/\\/g, '');

        options = options + `
            <option id="${townId}" value="${townId}">${town}</option>
          `;
      });
    });

    $('#specialStoreTownSelect').append(options);
  }

  autoAnimate(elem, time) {
    return new Promise((resolve, reject) => {
      try {
        let curHeight = $(elem).height();
        let autoHeight = $(elem).css('height', 'auto').height();
        $(elem).height(curHeight);
        $(elem).stop().animate({height: autoHeight}, time, function () {
          $(elem).css('height', 'auto')
        });
        resolve(true);
      } catch (e) {
        reject(e)
      }
    });
  }

  openPanel(target) {
    let animateTime = this.animateTime;
    $(target).addClass('is-open');
    this.autoAnimate(target, animateTime).then(res => {
      this.onScrollPage(target);
    }).catch(err => {
      console.log('cannot scroll page')
    });
  }


  onScrollPage(target) {
    const wh = window.innerHeight;
    const offset = $(target).offset().top
    let y = offset - 200;

    SmoothScroll(window, 0, y, 'smooth');
  }

  onValidateForm() {
    $('input#basicPrivacy[type="checkbox"]').prop('checked', false);

    $('input[type="checkbox"]').on('change.bt', (e) => {
      let prCheckbox = $(e.currentTarget);
      let button = prCheckbox.closest('form').find('button[type="submit"]');

      if (prCheckbox.is(':checked')) {
        button.attr('disabled', false);
      } else {
        button.attr('disabled', true);
      }
    });
  }

  scrollOnError() {
    if ($('.error:not(.d-none)').length > 0) {
      let y = $('.error:not(.d-none)').prev().offset().top;
      SmoothScroll(window, 0, y, 'smooth');
    }
  }


  render() {
    this.onValidateForm();
    selectStore();
    this.scrollOnError();
    this.townRegionAjax();

    let url = $('#specialStoreTownSelect')[0].dataset.url;

    $('#specialStoreTownSelect').change(function () {
      var selectedTown = $("#specialStoreTownSelect option:selected").attr('id');
      var feature = $(".feature").attr("value") || 'BOOKING_TOOL';

      $.ajax({
        type: "GET",
        contentType: "application/json",
        dataType: 'json',
        data: {
          selectedTown: selectedTown,
          feature: feature,
          getSpecialStoresFromTown: true
        },
        url: url,
        cache: false,
        success: function (response) {
          var myJSONText = JSON.stringify(response);
          var allSpecialStores = JSON.parse(myJSONText);
          fillDivWithSpecialStores(allSpecialStores);
        },
        error: function (errorObj, textStatus, errorThrown) {
        }
      });

    });

    function selectStore() {
      $("body").on("click", "input[type='radio'][name='storeOptionRadio']", function () {
        var storeId = $(this).val();
        $('#storeId').val(storeId);
      });
    }

    function fillDivWithSpecialStores(allSpecialStores) {
      var listOfStores = '';
      $('#specialStoresByTown').empty();

      $.each(allSpecialStores, function (index, store) {
        const code = store.name;
        const name = store.displayName;
        const indirizzo = store.address != null ? store.address.formattedAddress : '';
        const telefono = store.address != null ? store.address.phone : '';

        listOfStores = `
          <div class="mm_bt-store-item store-item-${index}">
            <div class="horizontal mm-custom-radio pin-cell">
              <input id="store_${index}" name="storeOptionRadio" type="radio" value="${store.name}">
              <label for="store_${index}"></label>
            </div>
            <div class="storeLocationBox desc-cell" id="${store.name}">
              <div class="store-locations ">
                <div class="store-nome">
                  <h3 class="bookingStoreName">${store.displayName}</h3>
                </div>
                <p>${store.address.formattedAddress}<br>
                  ${store.address.phone}
                </p>
              </div>
            </div>
          </div>
        `;
        $('#specialStoresByTown').append(listOfStores);

        if (index === 0) {
          $('.store-item-0').find('input#store_0').attr('checked', true);
          $('input#storeId').val(code);
        }
      });
    }
  }
}
